import Service from "@/services";

export default {
  namespaced: true,

  state: {},

  getters: {},

  actions: {
    async over_grid_data(_, payload) {
      try {
        const uuid = localStorage.getItem("uuid");
        const res = await Service().get(
          `${process.env.VUE_APP_OVER_VIEW_RIDER_PROFILE_JAVA_API_URL}/progressWall/${uuid}/${payload.year}/${payload.month}/${payload.week}`
        );
        return res;
      } catch (e) {
        console.log("Error: ", e);
        // Return a consistent error response structure
        return {
          success: false,
          data: null,
          error: e.message || "Failed to fetch data",
        };
      }
    },

    async over_view_bar_chart_data(_, payload) {
      try {
        const uuid = localStorage.getItem("uuid");
        let apiUrl = `${process.env.VUE_APP_OVER_VIEW_RIDER_PROFILE_JAVA_API_URL}/progress/${uuid}/year/${payload.year}`;

        if (payload.type === "week") {
          apiUrl = `${process.env.VUE_APP_OVER_VIEW_RIDER_PROFILE_JAVA_API_URL}/progress/${uuid}/week/${payload.year}/${payload.month}/${payload.week}`;
        } else if (payload.type === "month") {
          apiUrl = `${process.env.VUE_APP_OVER_VIEW_RIDER_PROFILE_JAVA_API_URL}/progress/${uuid}/month/${payload.year}/${payload.month}`;
        }

        const res = await Service().get(apiUrl);
        return res;
      } catch (e) {
        console.log("Error: ", e);
        // Return a consistent error response structure
        return {
          success: false,
          data: null,
          error: e.message || "Failed to fetch data",
        };
      }
    },
  },

  mutations: {},
};
